/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RiskProfileSources } from './RiskProfileSources';
import {
  RiskProfileSourcesFromJSON,
  RiskProfileSourcesFromJSONTyped,
  RiskProfileSourcesToJSON,
} from './RiskProfileSources';

/**
 *
 * @export
 * @interface RiskProfileSummary
 */
export interface RiskProfileSummary {
  /**
   *
   * @type {number}
   * @memberof RiskProfileSummary
   */
  readonly id: number;
  /**
   *
   * @type {number}
   * @memberof RiskProfileSummary
   */
  useCase: number;
  /**
   *
   * @type {RiskProfileSources}
   * @memberof RiskProfileSummary
   */
  readonly sources: RiskProfileSources;
}

/**
 * Check if a given object implements the RiskProfileSummary interface.
 */
export function instanceOfRiskProfileSummary(value: object): value is RiskProfileSummary {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('useCase' in value) || value['useCase'] === undefined) return false;
  if (!('sources' in value) || value['sources'] === undefined) return false;
  return true;
}

export function RiskProfileSummaryFromJSON(json: any): RiskProfileSummary {
  return RiskProfileSummaryFromJSONTyped(json, false);
}

export function RiskProfileSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): RiskProfileSummary {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    useCase: json['use_case'],
    sources: RiskProfileSourcesFromJSON(json['sources']),
  };
}

export function RiskProfileSummaryToJSON(value?: Omit<RiskProfileSummary, 'id' | 'sources'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    use_case: value['useCase'],
  };
}
